import React from 'react';
import { Link } from 'react-router-dom';
import Seo, { SITE } from '../../components/Seo/Seo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

import { generalFaqs } from '../../data/faqs';
import './FAQ.css';

// Renders the repo's real generalFaqs (unchanged text) as the design-system
// `.fq` brand accordion — native <details>/<summary>, no React state (matches
// the Surface-4 Lessons FAQ teaser). Answers may be a string or JSX (some carry
// inline <Link> to /policies, /lessons, mailto/tel) — both render in `.fq__a`.
const FAQ = () => {
	return (
		<main className='cyv faq-page'>
			<Seo
				title='FAQ | Color Your Voice'
				description='Answers to common questions about Color Your Voice lessons, summer workshops, registration, and studio policies.'
				canonical={`${SITE}/faq`}
			/>

			{/* ---- Hero (centered) ---- */}
			<header className='pg-hero'>
				<span className='eyebrow'>Questions</span>
				<h1 className='brand-heading'>Frequently asked questions</h1>
				<p>
					A few quick answers for families — about lessons, summer workshops, and
					how we work.
				</p>
			</header>

			{/* ---- Accordion (repo's generalFaqs, left-aligned) ---- */}
			<section className='fq'>
				{generalFaqs.map((f, i) => (
					<details key={i} open={i === 0}>
						<summary>
							{f.q} <FontAwesomeIcon icon={faChevronDown} />
						</summary>
						<div className='fq__a'>{f.a}</div>
					</details>
				))}
			</section>

			{/* ---- Closing CTA (centered) ---- */}
			<section className='fq-close'>
				<div className='fq-close__in'>
					<span className='accent-bar' />
					{/* Repointed from summer to fall 2026-08-08 — this CTA was one of the
					    last inbound links to /summer left on the marketing site. */}
					<Link className='btn-cyv-teal' to='/register'>
						Ready to register? Enroll for fall 2026 →
					</Link>
					<p>
						<strong>Questions we didn't cover?</strong> Email{' '}
						<a href='mailto:sing@coloryourvoice.com'>sing@coloryourvoice.com</a> or
						call <a href='tel:+19522830560'>(952) 283-0560</a>.
					</p>
				</div>
			</section>
		</main>
	);
};

export default FAQ;
